import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ourClient.css";
import heroimg from "../../images/Clients/Indian_Super_League_logo.svg";
import audiimg from "../../images/Clients/audilogo.svg";
import dlfimg from "../../images/Clients/dlf logo.svg";
import mtvimg from "../../images/Clients/mtv logo.svg";
import accentureimg from "../../images/Clients/Accenture.svg";
import nokiaimg from "../../images/Clients/Nokia_wordmark.svg";
import bradimg from "../../images/Clients/download 1.svg";
import hpimg from "../../images/Clients/hp-svgrepo-com.svg";
import hyundai from "../../images/Clients/hyundai.svg";
import honda from "../../images/Clients/honda-svgrepo-com.svg";
import microsoft from "../../images/Clients/microsoft-logo.svg";
import samsung from "../../images/Clients/samsung.svg";
import ibmimg from "../../images/Clients/ibm.svg";
import vodafone from "../../images/Clients/vodafone-.svg";

function OurClient() {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    // className: "client_logo_cont",
    // slidesToShow: 1,
    // slidesToScroll: 1,
    className: "center",
    adaptiveHeight: true,
    speed: 500,
    rows: 2,
    centerPadding: "60px",
    slidesPerRow: 4,
    variableWidth: true,
    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          rows: 2,
          slidesPerRow: 3,
        },
      },
      {
        breakpoint: 980,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          //   slidesToShow: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          //   slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container ourClient_cont">
      <p className="container_heading" style={{ marginBottom: "40px" }}>
        <span className="heading_first">Our</span> Clients
      </p>

      <Slider {...settings}>
        {/* { window.screen.width<400 ? */}
        {/* <div className="client_logos"> */}

        <div className="client_logo_cont">
          <img src={heroimg} className="client_logo" />
          {/* <img src={heroimg} className="client_logo" /> */}
        </div>

        <div className="client_logo_cont">
          <img src={nokiaimg} className="client_logo nokia_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={mtvimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={audiimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={dlfimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={accentureimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={bradimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          {/* <img src={hpimg} className="client_logo" /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="client_logo"
            aria-label="HP"
            role="img"
            fill="none"
            fillColor="none"
            viewBox="0 0 512 512"
          >
            <rect width="512" height="512" rx="15%" fill="none" />
            <path
              fill="#0096d6"
              d="M256 64c-2.9 0-5.8 0-8.6.2l-39.3 108h34.2c20.3 0 31.3 15.6 24.3 34.8l-48.4 133h-40.7l52-142.6H199L147 340h-40.6l61-168 36.9-101a192 192 0 0 0 7.2 371.7l35.7-98 62.8-172.7h75c20.3 0 31.3 15.7 24.3 34.9l-42.5 116.9a26.5 26.5 0 0 1-23.2 16.2h-54l-39.2 107.8 5.7.1a192 192 0 0 0 0-384zm85.6 133.3l-42.8 117.4h30.6l42.8-117.4z"
            />
          </svg>
        </div>

        <div className="client_logo_cont">
          <img src={hyundai} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={samsung} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={honda} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={microsoft} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={ibmimg} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img src={vodafone} className="client_logo" />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/8/8c/Philips_logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/e/e2/Hero_MotoCorp_Logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/sco/d/d8/Nestl%C3%A9.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://brandeps.com/logo-download/S/Snapdeal-logo-vector-01.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/a/af/Ranbaxy_Logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/en/a/ad/RBS_logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/d/de/Harley-Davidson_logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/22/Blackberry_Logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/c/cd/Taj_Hotels_logo.svg"
            className="client_logo"
          />
        </div>

        <div className="client_logo_cont">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/a/ae/Hindustan_Times_logo.svg"
            className="client_logo"
          />
        </div>
      </Slider>
    </div>
  );
}

export default OurClient;
